import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { approveOrRejectPurchaseRequest, getPurchaseRequestById } from "../../../../redux/features/purchaseRequest/purchaseRequestService";
import FilterDropdown from "../../../../components/FilterDropdown";
import { showToast } from "../../../../components/ToastMsg";
import { approveOrRejectRequest, getRequestById } from "../../../../redux/features/studentRegistration/studentRegistrationService";

const formatNumber = (value) =>
    new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);

const formatDate = (paid_date) => {
    const date = new Date(paid_date);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    const formatted = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formatted
}

const requestStatus = [
    { id: 'Approved', name: 'Approved' },
    { id: 'Reject', name: 'Reject' },
    { id: 'Pending', name: 'Pending' },
]

const RegistrationRequestDetails = () => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const approveDropdownRef = useRef();

    const { selectedRequest } = useSelector((state) => state.studentRegRequests.selectedRequest);

    const [disabledBtn, setBtnDisable] = useState(false);
    const [statusErr, setStatusErr] = useState(null);
    const [reasonErr, setReasonErr] = useState(null);

    const fetchCourseBatch = async () => {
        try {
            await dispatch(getRequestById({ id })).unwrap();
        } catch (error) {
            showToast('error', 'Unable to fetch batch information.');
        }
    }

    useEffect(() => {
        if (id) {
            fetchCourseBatch();
        }
    }, [id]);

    const submitRequestDecision = async () => {
        try {
            if (!selectedStatus) {
                setStatusErr('Request status is required.');
                return;
            }
            const date = new Date();
            if (selectedStatus === 'Reject') {
                if (!reason) {
                    setReasonErr('Reason is required.');
                    return;
                }
                const response = await dispatch(
                    approveOrRejectRequest({ id: id, status: 'Reject', approved_date: date, reason: reason }),
                ).unwrap();
            }
            setBtnDisable(true);
            const response = await dispatch(
                approveOrRejectRequest({ id: id, status: 'Approved', approved_date: date }),
            ).unwrap();
            showToast("success", response.message);
            setBtnDisable(false);
            if (approveDropdownRef.current) {
                approveDropdownRef.current.clearSelection();
            }
            setStatusSelect(null);
            setReason(null);
        } catch (error) {
            showToast("error", error.message);
            setBtnDisable(false);
        }
    };

    const [selectedStatus, setStatusSelect] = useState(null);
    const [reason, setReason] = useState(null);

    const handleRequestStatus = (option) => {
        setStatusSelect(option);
        setStatusErr(null);
    }

    return (
        <div className="card-section">
            <div className="main-card">
                <div className={styles.personalSec}>
                    <div className={styles.personalDetailsSec}>
                        <p>Name: {selectedRequest?.full_name}</p>
                        <p>Email: {selectedRequest?.email}</p>
                        <p>Phone Number: {selectedRequest?.phone_number}</p>

                        <h3>Coordinator</h3>
                        <p>Name: {selectedRequest?.coordinator?.full_name}</p>
                        <p>Email: {selectedRequest?.coordinator?.email}</p>
                        <p>Phone Number: {selectedRequest?.coordinator?.phone_number}</p>
                    </div>
                </div>
            </div>
            <div className="main-card">
                <h1 className={`form-title`}>Purchase Request Details <span className={`status-text-label ${selectedRequest?.status?.toLowerCase()}`}>{selectedRequest?.status}</span>
                </h1>
                <div className={styles.slipDetails}>
                    <div className={styles.formContainer}>
                        <p>{selectedRequest?.course?.title}</p>
                        <p>Course Fee: {formatNumber(selectedRequest?.course?.price)}</p>
                        <p>Order Amount: {formatNumber(selectedRequest?.order?.amount)}</p>
                        <p>Payment Type: {selectedRequest?.payment_type}</p>
                        <p>Paid Date: {formatDate(selectedRequest?.paid_date)}</p>
                        <img src={selectedRequest?.pay_slip} alt="pay slip" className={styles.slipImgMobile} />
                        <form className={styles.coordinatorForm} noValidate>
                            <div className="form-input-row">
                                <div className="form-input-col">
                                    <div className="form-input-group">
                                        <label className="form-label">
                                            Approve/ Reject<span className="required-star">*</span>
                                        </label>
                                        <FilterDropdown
                                            ref={approveDropdownRef}
                                            options={requestStatus}
                                            placeholder="Select a Status"
                                            onSelect={(option) => handleRequestStatus(option.id)}
                                            value={selectedStatus}
                                        />
                                        {statusErr && (
                                            <p className={`text-danger`}>{statusErr}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {selectedStatus === 'Reject' &&
                                <div className="form-input-row">
                                    <div className="form-input-col">
                                        <div className="form-input-group">
                                            <label className="form-label">
                                                Reason<span className="required-star">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="reason"
                                                value={reason}
                                                placeholder="Enter the reason"
                                                className="form-input-default"
                                                onChange={(e) => {
                                                    setReason(e.target.value);
                                                    setReasonErr(null);
                                                }}
                                            />
                                            {reasonErr && (
                                                <p className={`text-danger`}>{reasonErr}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            }
                            <button
                                className="btn-primary"
                                type="button"
                                disabled={disabledBtn}
                                onClick={submitRequestDecision}
                            >
                                {disabledBtn ? <span>Loading...</span> : `Create`}
                            </button>
                        </form>
                    </div>
                    <img src={selectedRequest?.pay_slip} alt="pay slip" className={styles.slipImg} />
                </div>
            </div>
        </div>
    );
};

export default RegistrationRequestDetails;